// extracted by css-extract-rspack-plugin
export default {"icon":"icon-HM1bKP"};